/**
 * Single source of truth for the Apace Pulse mark's shape and colors.
 * LogoMark (Logo.tsx) renders from these constants, and
 * `npm run generate:favicon` writes public/favicon.svg from the same
 * values — so the mark only ever needs to change in this one file.
 * Edit here, then re-run `npm run generate:favicon` to keep the static
 * favicon in sync.
 */
export const LOGO_VIEWBOX = '0 0 200 200';

export const LOGO_ARM_GRADIENT = {
  id: 'apacePulseArm',
  x1: '10%',
  y1: '0%',
  x2: '90%',
  y2: '100%',
  stops: [
    { offset: '0%', color: '#3B82F6' },
    { offset: '100%', color: '#6D28D9' },
  ],
} as const;

export const LOGO_FOLD_GRADIENT = {
  id: 'apacePulseFold',
  x1: '0%',
  y1: '0%',
  x2: '100%',
  y2: '100%',
  stops: [
    { offset: '0%', color: '#1E1B4B' },
    { offset: '100%', color: '#5B21B6' },
  ],
} as const;

export const LOGO_ARM_PATH = 'M35 178 L100 22 L165 178';
export const LOGO_ARM_STROKE_WIDTH = 34;

export const LOGO_FOLD_PATH = 'M55 178 Q80 145 98 120';
export const LOGO_FOLD_STROKE_WIDTH = 26;

export const LOGO_DOT = { cx: 124, cy: 152, r: 14, fill: '#C4B5FD' } as const;

export const APP_NAME = 'Apace Pulse';
export const APP_NAME_PARTS = { primary: 'Apace', accent: 'Pulse' } as const;
